export default "__VITE_ASSET__DzXjbkoa__"